// A commentable row of the read-only plan tables. Overall and channel rows
// are plan nodes (ids of the published version); quarterly rows are channel
// org nodes. The `?row=` value on the request page is `<section>:<id>`.
export type Section = 'overall' | 'channel' | 'quarterly'
export type AnchorType = 'TopDownPlanNode' | 'OrgNode'

export interface RowAnchor {
  section: Section
  anchor_type: AnchorType
  anchor_id: string
  label: string
}

const SECTIONS: Section[] = ['overall', 'channel', 'quarterly']

export function anchorTypeFor(section: Section): AnchorType {
  return section === 'quarterly' ? 'OrgNode' : 'TopDownPlanNode'
}

export function rowKey(a: Pick<RowAnchor, 'section' | 'anchor_id'>): string {
  return `${a.section}:${a.anchor_id}`
}

export function parseRowParam(value: string | null | undefined): { section: Section; anchor_id: string } | null {
  if (!value) return null
  const i = value.indexOf(':')
  if (i < 0) return null
  const section = value.slice(0, i) as Section
  const anchor_id = value.slice(i + 1)
  if (!SECTIONS.includes(section) || !anchor_id) return null
  return { section, anchor_id }
}
